import React, { useState, useRef, useEffect } from 'react';
import { Smile } from 'lucide-react';
import { Button } from './ui/button';

const EMOJIS = {
  'Smileys': ['😀','😃','😄','😁','😅','😂','🤣','😊','😇','🙂','🙃','😉','😍','🥰','😘','😗','😋','😜','🤪','😎','🤩','🥳','😏','😒','😞','😔','😢','😭','😤','😡','🥺','😱','😴','🤔','🤫','🤗','😬','🫣'],
  'Gestures': ['👍','👎','👋','🤝','👏','🙌','🤞','✌️','🤟','🤙','💪','🙏','🫶','👀','🫠','🤦','🤷','💅','🙋','🫡'],
  'Hearts': ['❤️','🧡','💛','💚','💙','💜','🖤','🤎','🤍','💯','💕','💖','💗','💓','💝','♥️','💘'],
  'Travel': ['🏠','🏡','🏢','🔑','🛏️','🏖️','🏔️','✈️','🚗','🚕','🚆','⛵','🗺️','🌍','🌴','☀️','🌙','⭐','🌈','🌊'],
  'Objects': ['📅','💰','💳','💵','📧','📱','☕','🍽️','🎉','✨','🔥','💡','📦','🎊','🎁','📸','🍾','🥂','🎶','⏰']
};

const EmojiPicker = ({ onSelect, className = '' }) => {
  const [open, setOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState('Smileys');
  const pickerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (pickerRef.current && !pickerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  return (
    <div className={`relative ${className}`} ref={pickerRef}>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-10 w-10 text-gray-500 hover:text-amber-500 transition-colors"
        onClick={() => setOpen(!open)}
        title="Add emoji"
      >
        <Smile size={20} />
      </Button>

      {open && (
        <div className="absolute bottom-12 right-0 w-[296px] bg-white border rounded-xl shadow-2xl z-50 animate-in fade-in slide-in-from-bottom-2 duration-200">
          {/* Category tabs */}
          <div className="flex border-b px-2 pt-2 gap-1 overflow-x-auto no-scrollbar">
            {Object.keys(EMOJIS).map(cat => (
              <button
                key={cat}
                type="button"
                className={`text-xs px-2 py-1.5 rounded-t-md whitespace-nowrap font-medium transition-colors ${
                  activeCategory === cat
                    ? 'bg-[#1F3A68] text-white'
                    : 'text-gray-500 hover:bg-gray-100 hover:text-gray-700'
                }`}
                onClick={() => setActiveCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Emoji grid */}
          <div className="p-2 grid grid-cols-8 gap-0.5 max-h-52 overflow-y-auto">
            {EMOJIS[activeCategory].map((emoji, i) => (
              <button
                key={i}
                type="button"
                className="w-8 h-8 flex items-center justify-center text-xl hover:bg-gray-100 rounded-md cursor-pointer transition-all hover:scale-110 active:scale-95"
                onClick={() => {
                  onSelect(emoji);
                  setOpen(false);
                }}
                title={emoji}
              >
                {emoji}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default EmojiPicker;
